import { render } from "./IOSTestflightUpgrade.vue?vue&type=template&id=9115bc1e"
import script from "./IOSTestflightUpgrade.vue?vue&type=script&lang=js"
export * from "./IOSTestflightUpgrade.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__